import React, { FC } from 'react';
import { IUserGet, IUserJSON } from '../types/Interface';
import { IStu } from '../types/Student';
import Row from './Row';
import RowOnly from './RowOnly';
import RowOnlyStu from './RowOnlyStu/RowOnlyStu';

interface ListOnlyStuProps {
  students?: any;
  // students?: IUserGet[] | null;
  // searchValue: string;
  // onChangeSearchValue: (e: React.FormEvent<HTMLInputElement>) => void;
  // onclickInvite?: any;
  // invites:any;
  isLoading?: boolean;
  tagSearch?: string;
  /**
   * Роль строки: 'student' (выбранные через «Выбрать») или 'tempUser' (созданные через «Новые»).
   * Используется для маршрутизации удаления строки в нужный массив state.
   */
  role?: 'student' | 'tempUser';
  /**
   * Индекс, с которого начинать нумерацию строк. Нужно, чтобы при раздельном рендере
   * tempStudents продолжали сквозную нумерацию после students.
   */
  startIndex?: number;
}

const ListOnlyStu: FC<ListOnlyStuProps> = ({ 
  students, isLoading, tagSearch, role, startIndex = 0
}) => {


  const listItems = students?.map((item: any, index: any) => {
  return <RowOnlyStu student={item} tagSearch={tagSearch} key={item["number"]} index={startIndex + index} role={role} />;
  }
  );
  const isEmpty = !listItems || (listItems as Array<any>).length === 0
  if (isEmpty) {
    // Плейсхолдер «Добавьте...» показываем только для основного списка students.
    // Для tempStudents (новые) при пустоте просто ничего не рендерим, чтобы не было двух подсказок.
    if (role === 'tempUser') {
      return null
    }
    isLoading = true
  }
  return (
    <>
      {isLoading ? (
        <div className='Lists'>
          Добавьте...
        </div>
      ) : (

          <div className='Lists-students'>
            <div className='Lists-students__name'>
              {listItems}
            </div>
          </div>

      )}
    </>
  )
}

export default ListOnlyStu;
